import JQueryView, { on } from '../../../common/views/jqueryView';

// 規約再同意モーダルの × クリックで dismiss cookie をセットする。
// Max-Age=900 (15 分) で短い抑制とし、Chrome のセッション復元 ON 環境でも再表示が保証される。
// モーダル自体の close は Bootstrap の data-dismiss="modal" が担当する。
const DISMISS_MAX_AGE_SECONDS = 60 * 15; // 15 minutes

export default class PolicyReconsentModalView extends JQueryView {
  constructor() {
    super('#policy_reconsent_modal');
  }

  @on({ event: 'click', selector: '.js-policy-reconsent-close' })
  onClickClose() {
    // HTTPS 配信時のみ Secure を付与。HTTP の dev 環境では Secure 付き cookie は保存されないため条件分岐する
    const secureAttr = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `policy_reconsent_dismissed=1; path=/; Max-Age=${DISMISS_MAX_AGE_SECONDS}; SameSite=Lax${secureAttr}`;
  }
}
